import React from 'react';

import * as styles from './styles.css';
import Box from '../../../Components/UI/Box';
import Lottie from '../../../Components/UI/Lottie';
import success from '../../../Svg/Lottie/success.json';

interface SuccessMessageProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  branding?: React.ReactNode;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ icon, title, description, branding }) => {
  return (
    <Box flex={1} display="flex" flexDirection="column" justifyContent="space-between">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        className={styles['message']}
        paddingHorizontal={4}
      >
        <Lottie animationData={success} className={styles['message-icon']}>
          {icon}
        </Lottie>
        <h2 className={styles['message-title']}>{title}</h2>
        <p className={styles['message-description']}>{description}</p>
      </Box>
      {branding && <Box className={styles['message-branding']}>{branding}</Box>}
    </Box>
  );
};

export default SuccessMessage;
